import { c as _c } from "react/compiler-runtime";
import clsxm from '../utils/style';
interface InfoGridProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Two-column grid for laying out a set of label/value pairs (typically `InfoRow`s).
 * Use this instead of hand-rolling `grid grid-cols-2 gap-x-8 gap-y-4` wrappers.
 */
export function InfoGrid(t0) {
  const $ = _c(5);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = clsxm("grid grid-cols-2 gap-x-8 gap-y-4", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <div className={t1}>{children}</div>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}